import { createRoot } from "react-dom/client";
import { FluentProvider, webLightTheme } from "@fluentui/react-components";
import { ConfigProvider } from "antd";
import '@ant-design/v5-patch-for-react-19';
import { themeProps } from "@alphascriptsolutions/client-core";
import App from "./App";

const rootElement: HTMLElement | null = document.getElementById("uploadDataRoot");
const root = rootElement ? createRoot(rootElement) : undefined;

Office.onReady(() => {
  root?.render(
    <ConfigProvider
      theme={{
        ...themeProps,
        token: {
          ...themeProps.token,
          fontSize: 13,
        },
        components: {
          Tree: {
            nodeHoverColor: '#ff5c35',
            nodeSelectedBg: '#f5f5f5',
            nodeSelectedColor: '#ff5c35',
          },
        },
      }}
    >
      <FluentProvider theme={webLightTheme}>
        <App />
      </FluentProvider>
    </ConfigProvider>
  );
});

